const getDeleteMessage = (objectName) =>
    interpolate(gettext('CONFIRM_DELETE_OBJECT'), [objectName]);

export default getDeleteMessage;
